import Vue from 'vue'
import Router from 'vue-router'
import sessionStorage from '../storage/sessionStorage'
import store from '@/storage/vuex'
import { Toast } from 'mint-ui';
const test = resolve => require(['@/components/test'],resolve);
// const Hello = resolve => require(['@/components/Hello'],resolve);
const missing = resolve => require(['@/components/404'],resolve);
const main = resolve => require(['@/components/main'],resolve);
const login = resolve => require(['@/components/login'],resolve);
const platFormLogin = resolve => require(['@/components/platFormLogin'],resolve);

import introduct from './introduct'
import ordering from './ordering'
import order from './order'
import exhibit from './exhibit'
import star from './star'
import pact from './pact'
import user from './user'
import submitOrder from './submitOrder'
import orderNew from './orderNew'
import orderNewPurchase from './orderNewPurchase'
import orderNewAgent from './orderNewAgent'

Vue.use(Router)
let toIndex = (to,from,next)=>{
	if(to.query.isInit){
		sessionStorage.$setSessionStorageByName('userInfo',{});
	}
	let userInfo = sessionStorage.$getSessionStorageByName('userInfo') || {};
	if(userInfo.id && !to.query.role){
		next(ordering[0])
	}else{
		next();
	}
}
let instance = null;
let r = new Router({
	routes : [
		{
			path : '*',
			name : 'missing',
			component : missing
		},
		{
			path : '/login',
			name : 'login',
			component : login,
			meta : {
				title : '订货端登录'
			},
			beforeEnter (to,from,next){
				toIndex(to,from,next);
			}
		},
		{
			path : '/platform/login',
			name : 'platFormLogin',
			component : platFormLogin,
			meta : {
				title : '订货端登录'
			},
		},
		// {
		// 	path : '/loginadmin',
		// 	name : 'loginadmin',
		// 	component : login,
		// 	meta : {
		// 		title : '登录'
		// 	},
		// 	beforeEnter (to,from,next){
		// 		toIndex(to,from,next);
		// 	}
		// },
		{
			path : '/',
			redirect : ordering[0],
		},
		{
			path : '/test',
			name : 'test',
			component : test
		},
		{
			path : '/main',
			component : main,
			beforeEnter (to,from,next){
				if(to.path === '/main'){
					next(ordering[0])
				}else{
					next()
				}
			},
			children : [].concat(introduct,ordering,order,exhibit,star,pact,user,submitOrder, orderNew,orderNewPurchase,orderNewAgent)
		}
	].reverse(),
	mode : (process.env.PLATFORM === 'testApp' || process.env.PLATFORM === 'app') ? 'hash' : 'history',
	scrollBehavior (){
		return {x : 10,y : 0}
	}
});

r.beforeEach(async (to,from,next)=>{
	document.body.scrollTop = 0;//防止下拉加载插件同时加载多次

	let userInfo = sessionStorage.$getSessionStorageByName('userInfo') || {};
	document.title = (typeof to.meta.title === 'function' ? to.meta.title(to) : to.meta.title) || '无标题';
	let notLoginName = { 'login': 1,'platFormLogin':1 }
	if(store.state.infer.coercePush && ['orderingInfer','login'].indexOf(to.name) < 0){
		if(['orderingInfer'].indexOf(to.name) < 0 && from.name !== 'orderingInfer'){
			next({
				name : 'orderingInfer'
			})
		}
		if(from.name === 'orderingInfer'){
			instance && instance.close();
			instance = Toast('强制推送中，不能进行该操作');
		}
		return;
	}
	if (!userInfo.id && !(to.name in notLoginName)) {
		next({
			name : 'login'
		})
	}else{
		let mainSearchHandle = to.meta.mainSearchHandle || function(){
			// console.log('未设置搜索函数')
		};
		store.commit("changeMainSearchHandle",mainSearchHandle);
		store.commit("changeSearchDisabled",to.meta.searchDisabled);
		store.commit("changeSearchKeyword",'');
		next()
	}
})

export default r



// WEBPACK FOOTER //
// ./src/router/index.js